// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3iFOt","inputWrap":"styles_inputWrap__1n55W","input":"styles_input__37nxb"};